// Types
import { OnboardingMetaDataResponseType } from './types';

// Constants
import { OB_STATUS, REG_KEYS } from 'constants/enums';
import { WHITELISTING_STATUS } from './constants';

export const formatWhitelistingDetails = (
  data: OnboardingMetaDataResponseType,
  status: string,
) => {
  const onboardingDetails = {
    status: {},
    locked: {
      testWebsiteUsername: true,
    },
    rejectionReasons: {},
    typeIdMap: {},
  };
  const rejectedKeys: string[] = [];
  const featureToggleMap: Record<string, boolean> = {};
  const { onboardingMetaData } = data;
  const isStatusPending = status === WHITELISTING_STATUS.ACTION_PENDING;
  const isStatusRejected = status === WHITELISTING_STATUS.REJECTED;
  const version =
    onboardingMetaData.length > 0 ? onboardingMetaData[0].version : undefined;
  data.onboardingMetaData.forEach(item => {
    const isWebsiteAppLink = [REG_KEYS.WEBSITE, REG_KEYS.APP_LINK].includes(
      item.regKey as REG_KEYS,
    );
    if (
      (isStatusRejected && !isWebsiteAppLink) ||
      (isStatusPending && isWebsiteAppLink)
    )
      return;
    onboardingDetails.locked[item.regKey] = true;
    if (item.isApproved === OB_STATUS.REJECTED) rejectedKeys.push(item.regKey);
    if (
      item.isApproved === OB_STATUS.REJECTED ||
      (isStatusPending && item.isApproved === OB_STATUS.UNAPPROVED)
    ) {
      featureToggleMap[item.regKey] = true;
      onboardingDetails[item.regKey] = item.regVal || 'Not Available';
      onboardingDetails.rejectionReasons[item.regKey] = item.rejectionReasons;
      onboardingDetails.status[item.regKey] = item.isApproved;
      onboardingDetails.typeIdMap[item.regKey] = item.id;
    }
  });

  if (isStatusPending) featureToggleMap.comments = true;
  return { onboardingDetails, rejectedKeys, featureToggleMap, version };
};

export const getRowStatusType = (type: string) => {
  switch (type) {
    case WHITELISTING_STATUS.IN_REVIEW:
    case WHITELISTING_STATUS.PENDING_APPROVAL:
      return 'APPROVAL_PENDING';
    case WHITELISTING_STATUS.ACTION_PENDING:
      return WHITELISTING_STATUS.REJECTED;
    default:
      return type;
  }
};

export const createTableHeadings = (showActions: boolean) => {
  const headers = [
    {
      key: 'addedOn',
      displayName: 'Added on',
      width: 0.2,
    },
    {
      key: 'referenceType',
      displayName: 'Type',
      width: 0.1,
    },
    {
      key: 'referenceValue',
      displayName: 'Website/App link',
      width: 0.3,
    },
    {
      key: 'ticketStatus',
      displayName: 'Status',
      width: 0.1,
    },
  ];
  if (showActions)
    headers.push({
      key: 'actions',
      displayName: '',
      width: 0.5,
    });
  return headers;
};
